<a class="link" [class.platform-name]="!leftHeaderLogoUrl" routerLink="/">
  @if (leftHeaderLogoUrl) {
    <img class="logo" [src]="leftHeaderLogoUrl" [alt]="title">
  } @else {
    {{ title }}
  }
</a>
